const imgs = {
    bg: `${process.env.PUBLIC_URL}/imgs/bg-not-found.png`,
    warning: `${process.env.PUBLIC_URL}/imgs/img_warning.png`,
};

const Forbidden = () => {
    return (
        <div className="relative w-full h-[calc(100vh-260px)] lg:h-[calc(100vh-145px)]">
            <div className="w-full h-full flex items-center justify-center">
                <img src={imgs["bg"]} width={"80%"} height={"auto"} />
            </div>
            <div className="error-text-message absolute w-full h-full flex flex-col gap-[30px] items-center justify-center top-0 left-0 text-center">
                <img src={imgs["warning"]} width="114px" height="100px" />
                <h2 className="text-3xl font-semibold">Forbidden</h2>
                <p className="text-2xl">
                    You do not have permission to access this page. <br />
                    Please check your credentials and try again. <br />
                    If you believe this is an error, contact our support team for assistance.
                </p>
            </div>
        </div>
    );
};

export default Forbidden;
